import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-h3 font-weight-bold mb-2" }
const _hoisted_2 = { class: "text-h6 font-weight-bold" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "text-subtitle-1" }
const _hoisted_5 = { class: "mb-3 mt-2" }
const _hoisted_6 = { class: "d-flex align-center justify-space-between mb-2" }
const _hoisted_7 = { class: "text-subtitle-2 font-weight-bold mb-1" }
const _hoisted_8 = {
  key: 0,
  class: "text-caption text-grey-darken-1 mb-0"
}
const _hoisted_9 = { class: "text-caption text-grey-darken-1 ml-1" }
const _hoisted_10 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "image-gallery" }
const _hoisted_13 = { class: "add-image-item" }
const _hoisted_14 = ["onChange"]
const _hoisted_15 = { class: "text-h6 font-weight-bold text-primary" }
const _hoisted_16 = { class: "text-h6 font-weight-bold" }
const _hoisted_17 = { class: "text-caption text-grey-darken-1" }
const _hoisted_18 = { class: "text-h6 font-weight-bold text-red" }
const _hoisted_19 = { class: "text-h5 font-weight-bold text-success" }
const _hoisted_20 = { class: "text-h6 mb-2" }
const _hoisted_21 = { class: "text-caption text-grey-darken-1" }

import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { generatePDFOptions as generatePDFUtilOptions, type PdfData } from '@/utils/pdfGenerator-opciones'
import { GalleryItem } from '@/interfaces/gallery.interface'
import { getImagePath, loadImageBase64 } from '@/utils/constantes'

interface Option {
  nombre: string
  descripcion: string
  selectedItems: any[]
  search: string
  expandedPanels: number[]
  expandedSections: { [key: number]: number[] }
  sectionImagesMap: Record<number, GalleryItem[]>  // ← NUEVO: Cada opción tiene su propio mapa
}

interface Seccion {
  SeccionID: number
  ServicioID: number
  NombreSeccion: string
  Descripcion: string
  ImagenesSeccion: string
  Orden: number
  items: Item[]
}

interface Item {
  ItemID: number
  SeccionID: number
  NombreItem: string
  ImagenesSeccion: string
  PrecioUnitario: any
  Descripcion: string
  Imagenes: string[]
  Orden: number
  NombreSeccion?: string
  NombreServicio?: string
  Cantidad?: number
}

// ============================================================================
// ESTADO
// ============================================================================

interface ImageItem {
  file: File;
  name: string;
  preview: string;
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'cotizacionNew'
},
  __name: 'cotizacionNew',
  setup(__props) {



const router = useRouter()
const store = useStore()

// ============================================================================
// INTERFACES
// ============================================================================

const nombreCliente = ref('')
const tipoEventoID = ref<number | null>(1)
const eventDate = ref(new Date().toISOString().split('T')[0])
const guestCount = ref<number | null>(50)
const discountPercent = ref(0)
const observations = ref('')
const saving = ref(false)
const loadingCatalog = ref(true)
const loaderGallery = ref(false)
const selectedImages = ref<ImageItem[]>([]);
const fileInput = ref(null);
const loaderImagen = ref(false)

const currentOption = ref<Option>({
  nombre: 'Opción 1',
  descripcion: '',
  selectedItems: [],
  search: '',
  expandedPanels: [],
  expandedSections: {},
  sectionImagesMap: {}  // ← NUEVO
})

// Galería
const gallery = ref<GalleryItem[]>([])
const tab = ref<string>('COT')
const loadSkeleton = ref(false)
const page = ref(1)
const itemsPerPage = ref(30)

// Sistema de opciones
const options = ref<Option[]>([
  {
    nombre: 'Opción 1',
    descripcion: '',
    selectedItems: [],
    search: '',
    expandedPanels: [],
    expandedSections: {},
    sectionImagesMap: {}  // ← NUEVO
  }
])
const selectedOptionTab = ref(0)

// Catálogo
const catalogoServicios = ref<any[]>([])
const tiposEvento = ref<any[]>([])
const payments = ref([{ amount: 0 }])

// Toast
const toast = ref({
  show: false,
  message: '',
  type: 'success'
})

// ============================================================================
// COMPUTED
// ============================================================================

const canSave = computed(() => {
  return nombreCliente.value && 
         tipoEventoID.value && 
         eventDate.value && 
         guestCount.value &&
         options.value.some(opt => opt.selectedItems.length > 0)
})

const gallerys = computed(() => store.state.Gallery.galleryList)

const subtotal = computed(() => {
  return options.value.reduce((sum, opt) => {
    return sum + opt.selectedItems.reduce((itemSum, item) =>
      itemSum + (Number.parseFloat(item.PrecioUnitario) || 0) * (item.Cantidad || 1), 0)
  }, 0)
})

const discountAmount = computed(() => {
  return (subtotal.value * discountPercent.value) / 100
})

const totalWithDiscount = computed(() => {
  return subtotal.value - discountAmount.value
})

const totalPayments = computed(() => {
  return payments.value.reduce((sum, p) => sum + (p.amount || 0), 0)
})

const pendingAmount = computed(() => {
  return totalWithDiscount.value - totalPayments.value
})

// ============================================================================
// MÉTODOS DE OPCIONES
// ============================================================================

function addOption() {
  const nextNumber = options.value.length + 1
  options.value.push({
    nombre: `Opción ${nextNumber}`,
    descripcion: '',
    selectedItems: [],
    search: '',
    expandedPanels: [],
    expandedSections: {},
    sectionImagesMap: {}  // ← NUEVO
  })
  selectedOptionTab.value = options.value.length - 1
}

function removeOption(index: number) {
  if (options.value.length === 1) {
    showToast('Debe existir al menos una opción', 'warning')
    return
  }
  options.value.splice(index, 1)
  if (selectedOptionTab.value >= options.value.length) {
    selectedOptionTab.value = options.value.length - 1
  }
}

// ============================================================================
// MÉTODOS DE CATÁLOGO
// ============================================================================

function getCatalogoFiltrado(optionIndex: number) {
  const searchTerm = options.value[optionIndex].search?.toLowerCase() || ''
  
  if (!searchTerm) {
    return catalogoServicios.value
  }

  return catalogoServicios.value.map(servicio => ({
    ...servicio,
    secciones: servicio.secciones.map((seccion: any) => ({
      ...seccion,
      items: seccion.items.filter((item: any) => 
        (item.NombreItem?.toLowerCase().includes(searchTerm) ||
        seccion.NombreSeccion?.toLowerCase().includes(searchTerm) ||
        servicio.NombreServicio?.toLowerCase().includes(searchTerm)) && item.Activo === 1
      )
    })).filter((seccion: any) => seccion.items.length > 0 && seccion.Activo === 1)
  })).filter(servicio => servicio.secciones.length > 0 && servicio.Activo === 1)
}

function changeSearchForOption(optionIndex: number) {
  const option = options.value[optionIndex]
  if (option.search && option.search.trim() !== '') {
    const filtrado = getCatalogoFiltrado(optionIndex)
    option.expandedPanels = filtrado.map((_, index) => index)
    filtrado.forEach((servicio: any) => {
      option.expandedSections[servicio.ServicioID] = servicio.secciones.map((_: any, index: number) => index)
    })
  } else {
    option.expandedPanels = []
    option.expandedSections = {}
  }
}

// ============================================================================
// MÉTODOS DE ITEMS
// ============================================================================

function isItemSelected(itemID: number, optionIndex: number): boolean {
  return options.value[optionIndex].selectedItems.some((i: any) => i.ItemID === itemID)
}

function toggleItem(item: Item, optionIndex: number) {
  const currentOption = options.value[optionIndex]
  const index = currentOption.selectedItems.findIndex(i => i.ItemID === item.ItemID)
  
  if (index > -1) {
    currentOption.selectedItems.splice(index, 1)
  } else {
    const seccion = findSeccionForItem(item.ItemID)
    const servicio = findServicioForSeccion(seccion?.SeccionID)
    const sectionImages = currentOption.sectionImagesMap[seccion?.SeccionID ?? 0] ?? []
    
    currentOption.selectedItems.push({
      ...item,
      Cantidad: 1,
      ImagenesSeccion: JSON.stringify(sectionImages.map((img: GalleryItem) => img.image)),
      NombreSeccion: seccion?.NombreSeccion,
      NombreServicio: servicio?.NombreServicio
    })
  }
}

function findSeccionForItem(itemID: number): Seccion | undefined {
  for (const servicio of catalogoServicios.value) {
    for (const seccion of servicio.secciones) {
      if (seccion.items.some((i: Item) => i.ItemID === itemID)) {
        return seccion
      }
    }
  }
  return undefined
}

function getItemsCountForService(servicioID: number, optionIndex: number): number {
  return options.value[optionIndex].selectedItems.filter((item: any) => 
    item.ServicioID === servicioID
  ).length
}

function getItemsCountForSection(seccionID: number, optionIndex: number): number {
  return options.value[optionIndex].selectedItems.filter((item: any) => 
    item.SeccionID === seccionID
  ).length
}

function getLengthItemsForService(servicioID: number, optionIndex: number): number {
  const servicio = catalogoServicios.value.find((s: any) => s.ServicioID === servicioID)
  if (!servicio) return 0
  return servicio.secciones.reduce((total: number, seccion: any) => total + seccion.items.length, 0)
}

function getTotalItemsCount(): number {
  return options.value.reduce((total, opt) => total + opt.selectedItems.length, 0)
}

function getItemCantidad(itemID: number, optionIndex: number): number {
  const item = options.value[optionIndex].selectedItems.find((i: any) => i.ItemID === itemID)
  return item?.Cantidad ?? 1
}

function updateItemCantidad(itemID: number, optionIndex: number, value: string | number) {
  const item = options.value[optionIndex].selectedItems.find((i: any) => i.ItemID === itemID)
  if (item) {
    item.Cantidad = Math.max(1, parseInt(String(value)) || 1)
  }
}

// ============================================================================
// MÉTODOS DE GESTIÓN DE IMÁGENES (CORREGIDOS)
// ============================================================================

function getSectionImages(seccionID: number, optionIndex: number): GalleryItem[] {
  const currentOption = options.value[optionIndex]
  return currentOption.sectionImagesMap[seccionID] || []
}

function updateSectionImages(seccionID: number, images: GalleryItem[], optionIndex: number) {
  const currentOption = options.value[optionIndex]
  currentOption.sectionImagesMap[seccionID] = [...images]
  
  // Actualizar items seleccionados de esta opción
  currentOption.selectedItems.forEach(item => {
    if (item.SeccionID === seccionID) {
      item.ImagenesSeccion = JSON.stringify(images.map((img: GalleryItem) => img.image))
    }
  })
}

// ============================================================================
// CÁLCULOS
// ============================================================================

function calculateSubtotalForOption(optionIndex: number): number {
  return options.value[optionIndex].selectedItems.reduce((sum: number, item: any) =>
    sum + parseFloat(item.PrecioUnitario || 0) * (item.Cantidad || 1), 0
  )
}

function calculateDiscountForOption(optionIndex: number): number {
  const subtotal = calculateSubtotalForOption(optionIndex)
  return subtotal * (discountPercent.value / 100)
}

function calculateTotalForOption(optionIndex: number): number {
  const subtotal = calculateSubtotalForOption(optionIndex)
  const discount = calculateDiscountForOption(optionIndex)
  return subtotal - discount
}

// ============================================================================
// CARGA DE DATOS
// ============================================================================

async function loadCatalog() {
  try {
    loadingCatalog.value = true
    await store.dispatch('Cotizacion/fetchCatalogo')
    
    const { servicios, secciones, items } = store.state.Cotizacion.Catalogo.data.data
    await store.dispatch('Cotizacion/getTiposEvento')
    tiposEvento.value = store.state.Cotizacion.TiposEvento.data.data
    
    const seccionesMap = new Map<number, Seccion>()
    // Filtrar secciones e items activos
    secciones.forEach((sec: any) => {
      if (sec.Activo === 0) return
      seccionesMap.set(sec.SeccionID, {
        ...sec,
        ImagenesSeccion: sec.ImagenesSeccion ? JSON.parse(sec.ImagenesSeccion) : [],
        items: items.filter((i: any) => i.SeccionID === sec.SeccionID && i.Activo === 1)
          .map((i: any) => ({
            ...i,
            Imagenes: i.Imagenes ? JSON.parse(i.Imagenes) : []
          }))
      })
    })
    // Filtrar servicios activos
    catalogoServicios.value = servicios.filter((serv: any) => serv.Activo === 1).map((serv: any) => ({
      ...serv,
      secciones: Array.from(seccionesMap.values())
        .filter(sec => sec.ServicioID === serv.ServicioID)
    }))

    loadingCatalog.value = false
  } catch (error) {
    console.error('Error cargando catálogo:', error)
    showToast('Error cargando el catálogo', 'error')
  } finally {
    loadingCatalog.value = false
  }
}

async function loadGallery() {
  loadSkeleton.value = true
  await store.dispatch('Gallery/fetchGallery', {
    params: {
      page: page.value,
      limit: itemsPerPage.value,
      type: tab.value,
    }
  })
  gallery.value = gallerys.value?.data.items ?? []
  loadSkeleton.value = false
}

function onTipoEventoChange() {
  // Lógica adicional si es necesaria
}

// ============================================================================
// GUARDADO Y PDF
// ============================================================================
async function guardarGaleria({ data, imageFile }: { data: GalleryItem; imageFile: File | null }) {
  loaderGallery.value = true
  const formData = new FormData()
  formData.append('adicional_class', data.adicional_class ?? '')
  formData.append('category', data.category)
  formData.append('description', data.description)
  formData.append('filter', data.filter ?? '')
  formData.append('status', data.status ?? 'A')
  formData.append('title', data.title)
  formData.append('type', data.type)
  if (imageFile) {
    formData.append('image', imageFile)
  } else if (data.image && !data.image.startsWith('http')) {
    try {
      const image = await urlToFile(getImagePath(data.image), data.image)
      formData.append('image', image)
    } catch (error) {
      console.error('Error convirtiendo imagen existente en archivo:', error)
    }
  }
  await store.dispatch('Gallery/postGallery', formData)
  // loaderGallery.value = false
  // snackbar.value = true
  // if (statusInsertGallery.value?.success) {
  //   dialogEdit.value = false
  //   cargarGaleria()
  // }
}
async function urlToFile(url: string, filename: string, mimeType = 'image/jpeg'): Promise<File> {
  const response = await fetch(url, {
    method: 'GET',
    mode: 'cors',
  })
  const blob = await response.blob()
  return new File([blob], filename.split('/').pop() || 'image.jpg', { type: mimeType })
}
async function saveQuotation() {
  if (!canSave.value) {
    showToast('Por favor completa todos los campos requeridos', 'warning')
    return
  }

  try {
    saving.value = true

    const pdfData: PdfData = {
      nombreCliente: nombreCliente.value,
      tipoEvento: tiposEvento.value.find(t => t.TipoEventoID === tipoEventoID.value)?.NombreTipo || '',
      selectedItems: options.value,
      catalogoServicios: catalogoServicios.value,
      eventDate: eventDate.value,
      guestCount: guestCount.value || 0,
      discountPercent: discountPercent.value,
      discountAmount: discountAmount.value,
      subtotal: subtotal.value,
      totalWithDiscount: totalWithDiscount.value,
      payments: payments.value,
      pendingAmount: totalWithDiscount.value,
      observations: '',
      opciones: options.value.map((option, index) => ({
        numero: index + 1,
        nombre: option.nombre,
        descripcion: option.descripcion,
        selectedItems: option.selectedItems.map((item: any) => ({
          ...item,
          ImagenesSeccion: item.ImagenesSeccion ? JSON.parse(item.ImagenesSeccion) : [] //nombre de la imagen ejemplo "['test.png']"
        })),
        subtotal: calculateSubtotalForOption(index),
        discountAmount: calculateDiscountForOption(index),
        totalWithDiscount: calculateTotalForOption(index)
      })),
      backgroundRespage: await loadImageBase64('/pdf/bk_pdf.png'),
      backgroundHeader: await loadImageBase64('/pdf/header.png'),
      signatureImage: await loadImageBase64('/pdf/firma.png')
    }
    
    // Preparar datos para cada opción
    const opcionesData = options.value.map((option, index) => ({
      numeroOpcion: index + 1,
      nombreOpcion: option.nombre,
      descripcion: option.descripcion,
      items: option.selectedItems.map(item => ({
        itemID: item.ItemID,
        cantidad: item.Cantidad || 1,
        observaciones: ''
      }))
    }))

    const payload = {
      NombreCliente: nombreCliente.value,
      TipoEventoID: tipoEventoID.value,
      FechaEvento: eventDate.value,
      NumeroInvitados: guestCount.value,
      PorcentajeDescuento: discountPercent.value,
      Observaciones: observations.value,
      DiasExpiracion: 7,
      Opciones: opcionesData,
      PdfData: JSON.stringify(pdfData)
    }

    await store.dispatch('Cotizacion/createCotizacionConOpciones', payload)
    const result = store.state.Cotizacion.result
    
    if (result.success) {
      showToast(result.message)
      resetForm() 
      gotoOptions()
    } else {
      showToast(result.message, 'error')
    }
  } catch (error: any) {
    console.error('Error guardando cotización:', error)
    showToast(error.response?.data?.message || 'Error al guardar la cotización', 'error')
  } finally {
    saving.value = false
  }
}

async function generatePDF() {
  if (!canSave.value) {
    showToast('Por favor completa todos los campos requeridos', 'error')
    return
  }

  saving.value = true
  try {
    const pdfData: PdfData = {
      nombreCliente: nombreCliente.value,
      tipoEvento: tiposEvento.value.find(t => t.TipoEventoID === tipoEventoID.value)?.NombreTipo || '',
      eventDate: eventDate.value,
      guestCount: guestCount.value || 0,
      discountPercent: discountPercent.value,
      observations: observations.value,
      opciones: options.value.map((option, index) => ({
        numero: index + 1,
        nombre: option.nombre,
        descripcion: option.descripcion,
        selectedItems: option.selectedItems,
        subtotal: calculateSubtotalForOption(index),
        discountAmount: calculateDiscountForOption(index),
        totalWithDiscount: calculateTotalForOption(index)
      })),
      catalogoServicios: catalogoServicios.value,
      payments: [],
      pendingAmount: 0,
      selectedItems: [],
      subtotal: 0,
      discountAmount: 0,
      totalWithDiscount: 0,
      backgroundRespage: await loadImageBase64('/pdf/bk_pdf.png'),
      backgroundHeader: await loadImageBase64('/pdf/header.png'),
      signatureImage: await loadImageBase64('/pdf/firma.png')
    }
    
    await generatePDFUtilOptions(pdfData)
    showToast('✅ PDF generado exitosamente')
  } catch (error) {
    console.error('Error generando PDF:', error)
    showToast('Error al generar el PDF', 'error')
  } finally {
    saving.value = false
  }
}

// ============================================================================
// UTILIDADES
// ============================================================================

function resetForm() {
  nombreCliente.value = ''
  tipoEventoID.value = 1
  eventDate.value = new Date().toISOString().split('T')[0]
  guestCount.value = 50
  discountPercent.value = 0
  observations.value = ''
  options.value = [{
    nombre: 'Opción 1',
    descripcion: '',
    selectedItems: [],
    search: '',
    expandedPanels: [],
    expandedSections: {},
    sectionImagesMap: {}
  }]
  selectedOptionTab.value = 0
}

function formatCurrency(value: number | string) {
  if (typeof value === 'string') {
    value = Number.parseFloat(value)
  }
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0
  }).format(value || 0)
}

function goToList() {
  router.push('/cotizaciones/list')
}

function gotoOptions() {
  router.push({ path: '/cotizaciones/opciones', query: { from: 'new' } }) // que mande una bandera para recargar la vista cuando venga de aqui
}

function showToast(message: string, type = 'success') {
  toast.value = { show: true, message, type }
}

function toggleAllItemsForService(servicioID: number, optionIndex: number) {
  const servicio = catalogoServicios.value.find(s => s.ServicioID === servicioID)
  if (!servicio) return

  const currentOption = options.value[optionIndex]
  const allItems: Item[] = []
  
  servicio.secciones.forEach((seccion: any) => {
    const sectionImages = currentOption.sectionImagesMap[seccion.SeccionID] ?? []
    seccion.items.forEach((item: any) => {
      allItems.push({
        ...item,
        ImagenesSeccion: JSON.stringify(sectionImages.map((img: GalleryItem) => img.image)),
        NombreSeccion: seccion.NombreSeccion,
        NombreServicio: servicio.NombreServicio
      })
    })
  })
  
  const allSelected = allItems.every(item => isItemSelected(item.ItemID, optionIndex))
  
  if (allSelected) {
    allItems.forEach(item => {
      const index = currentOption.selectedItems.findIndex(i => i.ItemID === item.ItemID)
      if (index > -1) {
        currentOption.selectedItems.splice(index, 1)
      }
    })
  } else {
    allItems.forEach(item => {
      if (!isItemSelected(item.ItemID, optionIndex)) {
        currentOption.selectedItems.push({ ...item, Cantidad: 1 })
      }
    })
  }
}

function toggleAllItemsForSection(seccionID: number, items: Item[], optionIndex: number) {
  const seccion = findSeccionById(seccionID)
  if (!seccion) return
  
  const servicio = findServicioForSeccion(seccionID)
  const currentOption = options.value[optionIndex]
  const allSelected = items.every(item => isItemSelected(item.ItemID, optionIndex))
  
  if (allSelected) {
    items.forEach(item => {
      const index = currentOption.selectedItems.findIndex(i => i.ItemID === item.ItemID)
      if (index > -1) {
        currentOption.selectedItems.splice(index, 1)
      }
    })
  } else {
    items.forEach(item => {
      if (!isItemSelected(item.ItemID, optionIndex)) {
        const sectionImages = currentOption.sectionImagesMap[seccion.SeccionID] ?? []
        currentOption.selectedItems.push({
          ...item,
          Cantidad: 1,
          ImagenesSeccion: JSON.stringify(sectionImages.map((img: GalleryItem) => img.image)),
          NombreSeccion: seccion.NombreSeccion,
          NombreServicio: servicio?.NombreServicio
        })
      }
    })
  }
}

function findSeccionById(seccionID: number): Seccion | undefined {
  for (const servicio of catalogoServicios.value) {
    const seccion = servicio.secciones.find((s: any) => s.SeccionID === seccionID)
    if (seccion) return seccion
  }
  return undefined
}

function findServicioForSeccion(seccionID: number | undefined): any {
  if (!seccionID) return undefined
  return catalogoServicios.value.find((s: any) => 
    s.secciones.some((sec: any) => sec.SeccionID === seccionID)
  )
}

/**
 * Maneja la subida de imágenes a una sección
 */
async function handleImageUpload(event: Event, seccionID: number, optionIndex: number) {
  const target = event.target as HTMLInputElement
  const files = target.files
  if (!files || files.length === 0) return

  const currentOption = options.value[optionIndex]
  
  // Inicializar el array si no existe
  if (!currentOption.sectionImagesMap[seccionID]) {
    currentOption.sectionImagesMap[seccionID] = []
  }

  loaderGallery.value = true

  for (const file of Array.from(files)) {
    // Validar que sea una imagen
    if (!file.type.startsWith('image/')) {
      console.warn(`${file.name} no es una imagen válida`)
      showToast(`${file.name} no es una imagen válida`, 'error')
      continue
    }

    // Validar tamaño (máximo 5MB)
    const maxSize = 5 * 1024 * 1024 // 5MB
    if (file.size > maxSize) {
      console.warn(`${file.name} excede el tamaño máximo de 5MB`)
      showToast(`${file.name} excede el tamaño máximo de 5MB`, 'error')
      continue
    }

    try {
      loaderImagen.value = true
      // Subir la imagen al servidor usando la función existente
      const formData = new FormData()
      formData.append('adicional_class', '')
      formData.append('category', 'cotizacion')
      formData.append('description', `Imagen de sección ${seccionID}`)
      formData.append('filter', '')
      formData.append('status', 'A')
      formData.append('title', file.name)
      formData.append('type', 'COT')
      formData.append('image', file)
      formData.append('isSaveInDB', '0') // ← Cambiado a '0' para que no se guarde en la base de datos
      await store.dispatch('Gallery/postGallery', formData)
      const statusInsertGallery = store.state.Gallery.statusInsertGallery

      if (statusInsertGallery?.success) {
        // Obtener el nombre del archivo guardado desde la respuesta
        const savedImageName = statusInsertGallery.data?.image || file.name
        
        // Agregar la imagen al mapa de la sección con el nombre del archivo
        currentOption.sectionImagesMap[seccionID].push({
          image: normalizeFileName(savedImageName), // ← Nombre del archivo en lugar de base64
          title: normalizeFileName(file.name),
          id: statusInsertGallery.data?.id || 0,
          category: 'cotizacion',
          type: 'COT',
          filter: '',
          adicional_class: '',
          description: `Imagen de sección ${seccionID}`,
          status: 'A'
        })

        // Actualizar los items seleccionados de esta sección
        updateSelectedItemsWithImages(seccionID, optionIndex)
        
        showToast(`✅ Imagen ${file.name} cargada exitosamente`, 'success')
      } else {
        showToast(`Error al subir ${file.name}`, 'error')
      }
    } catch (error) {
      console.error(`Error al procesar el archivo ${file.name}:`, error)
      showToast(`Error al cargar ${file.name}`, 'error')
    }
  }

  loaderGallery.value = false

  // Limpiar el input para permitir seleccionar el mismo archivo nuevamente
  target.value = ''
  loaderImagen.value = false
}
 
 function normalizeFileName(fileName: string): string {
  return fileName.replace(/[^a-zA-Z0-9_\.\-]/g, '_')
}
/**
 * Elimina una imagen de una sección
 */
function removeImageFromSection(seccionID: number, imageIndex: number, optionIndex: number) {
  const currentOption = options.value[optionIndex]
  
  if (!currentOption.sectionImagesMap[seccionID]) return

  // Eliminar la imagen del array
  currentOption.sectionImagesMap[seccionID].splice(imageIndex, 1)

  // Actualizar los items seleccionados de esta sección
  updateSelectedItemsWithImages(seccionID, optionIndex)
}

/**
 * Actualiza las imágenes en los items seleccionados de una sección
 */
function updateSelectedItemsWithImages(seccionID: number, optionIndex: number) {
  const currentOption = options.value[optionIndex]
  const sectionImages = currentOption.sectionImagesMap[seccionID] ?? []
  
  // Actualizar todos los items seleccionados de esta sección
  currentOption.selectedItems.forEach((item: Item) => {
    if (item.SeccionID === seccionID) {
      item.ImagenesSeccion = JSON.stringify(sectionImages.map((img: GalleryItem) => img.image))
    }
  })
}

// ============================================================================
// LIFECYCLE
// ============================================================================

onMounted(async () => {
  await loadCatalog()
  await loadGallery()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "quotation-options-container"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "mb-6 header-card",
        elevation: "8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "pa-8" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                align: "center",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "8"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", _hoisted_1, [
                        _createVNode(_component_v_icon, {
                          size: "30",
                          color: "white"
                        }, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createTextVNode("mdi-folder-multiple")
                          ])),
                          _: 1,
                          __: [11]
                        }),
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "ml-2 text-h4 text-white font-weight-bold mb-2" }, "Nueva Cotización con Opciones", -1))
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-h6 mb-0 subtitle" }, "Crea múltiples propuestas para el mismo evento", -1))
                    ]),
                    _: 1,
                    __: [13]
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4",
                    class: "text-right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "white",
                        variant: "outlined",
                        size: "large",
                        "prepend-icon": "mdi-format-list-bulleted",
                        onClick: goToList
                      }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode(" Ver Cotizaciones ")
                        ])),
                        _: 1,
                        __: [14]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-6",
        elevation: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5 pa-6 bg-grey-lighten-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                start: "",
                color: "primary"
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("mdi-account-multiple")
                ])),
                _: 1,
                __: [15]
              }),
              _cache[16] || (_cache[16] = _createTextVNode(" Información del Evento "))
            ]),
            _: 1,
            __: [16]
          }),
          _createVNode(_component_v_card_text, { class: "pa-6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: tipoEventoID.value,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((tipoEventoID).value = $event)),
                          onTipoEventoChange
                        ],
                        items: tiposEvento.value,
                        "item-title": "NombreTipo",
                        "item-value": "TipoEventoID",
                        label: "Tipo de Evento",
                        variant: "outlined",
                        density: "comfortable",
                        "prepend-inner-icon": "mdi-party-popper",
                        rules: [v => !!v || 'Campo requerido']
                      }, null, 8, ["modelValue", "items", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: nombreCliente.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nombreCliente).value = $event)),
                        label: "Nombre del Cliente",
                        placeholder: "Ej: Juan Pérez",
                        variant: "outlined",
                        density: "comfortable",
                        "prepend-inner-icon": "mdi-account",
                        rules: [v => !!v || 'Campo requerido']
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: eventDate.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((eventDate).value = $event)),
                        label: "Fecha del Evento",
                        type: "date",
                        variant: "outlined",
                        density: "comfortable",
                        "prepend-inner-icon": "mdi-calendar",
                        rules: [v => !!v || 'Campo requerido']
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: guestCount.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((guestCount).value = $event)),
                        modelModifiers: { number: true },
                        label: "Número de Invitados",
                        type: "number",
                        placeholder: "100",
                        variant: "outlined",
                        density: "comfortable",
                        "prepend-inner-icon": "mdi-account-group",
                        rules: [v => !!v || 'Campo requerido']
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-6",
        elevation: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5 pa-6 bg-primary text-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { start: "" }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode("mdi-layers-triple")
                ])),
                _: 1,
                __: [17]
              }),
              _cache[21] || (_cache[21] = _createTextVNode(" Opciones de Cotización ")),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "white",
                variant: "outlined",
                size: "small",
                "prepend-icon": "mdi-plus-circle",
                onClick: addOption
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode(" Agregar Opción ")
                ])),
                _: 1,
                __: [18]
              }),
              _createVNode(_component_v_btn, {
                color: "white",
                variant: "outlined",
                size: "small",
                "prepend-icon": "mdi-refresh",
                onClick: _withModifiers(loadCatalog, ["stop"]),
                class: "ml-2"
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode(" Cargar Servicios ")
                ])),
                _: 1,
                __: [19]
              }),
              _createVNode(_component_v_btn, {
                color: "white",
                variant: "outlined",
                size: "small",
                "prepend-icon": "mdi-reload",
                onClick: _withModifiers(resetForm, ["stop"]),
                class: "ml-2"
              }, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createTextVNode(" Reiniciar Todo ")
                ])),
                _: 1,
                __: [20]
              })
            ]),
            _: 1,
            __: [21]
          }),
          _createVNode(_component_v_tabs, {
            modelValue: selectedOptionTab.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedOptionTab).value = $event)),
            "bg-color": "grey-lighten-4",
            color: "primary",
            "show-arrows": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, index) => {
                return (_openBlock(), _createBlock(_component_v_tab, {
                  key: index,
                  value: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-numeric-" + _toDisplayString(index + 1) + "-box", 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createTextVNode(" " + _toDisplayString(option.nombre) + " ", 1),
                    (options.value.length > 1)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          icon: "mdi-close",
                          size: "x-small",
                          variant: "text",
                          color: "error",
                          class: "ml-2",
                          onClick: _withModifiers(($event: any) => (removeOption(index)), ["stop"])
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_window, {
            modelValue: selectedOptionTab.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedOptionTab).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, optionIndex) => {
                return (_openBlock(), _createBlock(_component_v_window_item, {
                  key: optionIndex,
                  value: optionIndex
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "pa-6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { class: "mb-4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: option.nombre,
                                  "onUpdate:modelValue": ($event: any) => ((option.nombre) = $event),
                                  label: "Nombre de la Opción",
                                  placeholder: "Ej: Decoración Completa",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "prepend-inner-icon": "mdi-rename-box"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: option.descripcion,
                                  "onUpdate:modelValue": ($event: any) => ((option.descripcion) = $event),
                                  label: "Descripción (opcional)",
                                  placeholder: "Breve descripción de esta opción",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "prepend-inner-icon": "mdi-text"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_text_field, {
                          modelValue: option.search,
                          "onUpdate:modelValue": ($event: any) => ((option.search) = $event),
                          label: "Buscar servicios o items para esta opción",
                          placeholder: "Buscar...",
                          variant: "outlined",
                          density: "comfortable",
                          "prepend-inner-icon": "mdi-magnify",
                          clearable: "",
                          class: "mb-4",
                          onInput: ($event: any) => (changeSearchForOption(optionIndex))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"]),
                        _createVNode(_component_v_expansion_panels, {
                          modelValue: option.expandedPanels,
                          "onUpdate:modelValue": ($event: any) => ((option.expandedPanels) = $event),
                          multiple: "",
                          variant: "accordion"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getCatalogoFiltrado(optionIndex), (servicio) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_v_expansion_panel, {
                                key: servicio.ServicioID,
                                elevation: "2",
                                class: "mb-3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, { class: "bg-grey-lighten-5" }, {
                                    default: _withCtx(({ expanded }) => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        align: "center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "8",
                                            class: "d-flex align-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, {
                                                color: expanded ? 'primary' : 'grey',
                                                class: "mr-3"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(expanded ? 'mdi-chevron-down' : 'mdi-chevron-right'), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["color"]),
                                              _createElementVNode("span", _hoisted_2, _toDisplayString(servicio.NombreServicio), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "4",
                                            class: "text-right"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_chip, {
                                                color: getItemsCountForService(servicio.ServicioID, optionIndex) > 0 ? 'primary' : 'grey',
                                                variant: "flat",
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    start: "",
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                                                      _createTextVNode("mdi-check-circle")
                                                    ])),
                                                    _: 1,
                                                    __: [22]
                                                  }),
                                                  _createTextVNode(" " + _toDisplayString(getItemsCountForService(servicio.ServicioID, optionIndex)) + " seleccionados ", 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["color"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_3, [
                                        _createVNode(_component_v_btn, {
                                          color: getItemsCountForService(servicio.ServicioID, optionIndex) > 0 ? 'success' : 'primary',
                                          variant: "outlined",
                                          size: "small",
                                          onClick: ($event: any) => (toggleAllItemsForService(servicio.ServicioID, optionIndex))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { start: "" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(getItemsCountForService(servicio.ServicioID, optionIndex) > 0 ? 'mdi-check-all' : 'mdi-plus-box-multiple'), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _cache[23] || (_cache[23] = _createTextVNode(" Seleccionar Todos "))
                                          ]),
                                          _: 2,
                                          __: [23]
                                        }, 1032, ["color", "onClick"])
                                      ]),
                                      _createVNode(_component_v_expansion_panels, {
                                        modelValue: option.expandedSections[servicio.ServicioID],
                                        "onUpdate:modelValue": ($event: any) => ((option.expandedSections[servicio.ServicioID]) = $event),
                                        multiple: ""
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(servicio.secciones, (seccion) => {
                                            return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                              key: seccion.SeccionID,
                                              elevation: "1",
                                              class: "mb-2",
                                              disabled: seccion.items.length === 0
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_expansion_panel_title, { class: "bg-blue-grey-lighten-5" }, {
                                                  default: _withCtx(({ expanded }) => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      align: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "9",
                                                          class: "d-flex align-center"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, {
                                                              color: expanded ? 'secondary' : 'grey-darken-1',
                                                              size: "small",
                                                              class: "mr-2"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(expanded ? 'mdi-folder-open' : 'mdi-folder'), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["color"]),
                                                            _createElementVNode("span", _hoisted_4, _toDisplayString(seccion.NombreSeccion) + " " + _toDisplayString((seccion.items.length === 0) ? '(Sin items)' : ''), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          class: "text-right"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_chip, {
                                                              color: getItemsCountForSection(seccion.SeccionID, optionIndex) > 0 ? 'secondary' : 'grey-lighten-1',
                                                              size: "x-small"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(getItemsCountForSection(seccion.SeccionID, optionIndex)) + "/" + _toDisplayString(seccion.items.length), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["color"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_expansion_panel_text, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_5, [
                                                      _createVNode(_component_v_btn, {
                                                        color: getItemsCountForSection(seccion.SeccionID, optionIndex) > 0 ? 'secondary' : 'grey',
                                                        variant: "text",
                                                        size: "x-small",
                                                        onClick: ($event: any) => (toggleAllItemsForSection(seccion.SeccionID, seccion.items, optionIndex))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, {
                                                            start: "",
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                              _createTextVNode("mdi-checkbox-multiple-marked")
                                                            ])),
                                                            _: 1,
                                                            __: [24]
                                                          }),
                                                          _cache[25] || (_cache[25] = _createTextVNode(" Seleccionar todos de esta sección "))
                                                        ]),
                                                        _: 2,
                                                        __: [25]
                                                      }, 1032, ["color", "onClick"])
                                                    ]),
                                                    _createVNode(_component_v_row, { class: "pa-2" }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seccion.items, (item) => {
                                                          return (_openBlock(), _createBlock(_component_v_col, {
                                                            key: item.ItemID,
                                                            cols: "12",
                                                            md: "6",
                                                            lg: "4"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_card, {
                                                                class: _normalizeClass(['item-card', { 'selected': isItemSelected(item.ItemID, optionIndex) }]),
                                                                elevation: "2",
                                                                onClick: ($event: any) => (toggleItem(item, optionIndex))
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_card_text, null, {
                                                                    default: _withCtx(() => [
                                                                      _createElementVNode("div", _hoisted_6, [
                                                                        (isItemSelected(item.ItemID, optionIndex))
                                                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                              key: 0,
                                                                              color: "success"
                                                                            }, {
                                                                              default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                                                _createTextVNode(" mdi-check-decagram ")
                                                                              ])),
                                                                              _: 1,
                                                                              __: [26]
                                                                            }))
                                                                          : (_openBlock(), _createBlock(_component_v_icon, {
                                                                              key: 1,
                                                                              color: "grey"
                                                                            }, {
                                                                              default: _withCtx(() => _cache[27] || (_cache[27] = [
                                                                                _createTextVNode(" mdi-decagram-outline ")
                                                                              ])),
                                                                              _: 1,
                                                                              __: [27]
                                                                            })),
                                                                        _createVNode(_component_v_chip, {
                                                                          color: "primary",
                                                                          size: "small",
                                                                          variant: "flat"
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(formatCurrency(item.PrecioUnitario)), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024)
                                                                      ]),
                                                                      _createElementVNode("p", _hoisted_7, _toDisplayString(item.NombreItem), 1),
                                                                      (item.Descripcion)
                                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(item.Descripcion), 1))
                                                                        : _createCommentVNode("", true),
                                                                      (isItemSelected(item.ItemID, optionIndex))
                                                                        ? (_openBlock(), _createElementBlock("div", {
                                                                            key: 1,
                                                                            class: "mt-3 d-flex align-center gap-2",
                                                                            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                                                                          }, [
                                                                            _createVNode(_component_v_btn, {
                                                                              icon: "mdi-minus",
                                                                              size: "x-small",
                                                                              variant: "outlined",
                                                                              color: "primary",
                                                                              onClick: _withModifiers(($event: any) => (updateItemCantidad(item.ItemID, optionIndex, getItemCantidad(item.ItemID, optionIndex) - 1)), ["stop"])
                                                                            }, null, 8, ["onClick"]),
                                                                            _createVNode(_component_v_text_field, {
                                                                              "model-value": getItemCantidad(item.ItemID, optionIndex),
                                                                              "onUpdate:modelValue": ($event: any) => (updateItemCantidad(item.ItemID, optionIndex, $event)),
                                                                              type: "number",
                                                                              min: "1",
                                                                              variant: "outlined",
                                                                              density: "compact",
                                                                              "hide-details": "",
                                                                              class: "cantidad-field",
                                                                              onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                                                                            }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                                                            _createVNode(_component_v_btn, {
                                                                              icon: "mdi-plus",
                                                                              size: "x-small",
                                                                              variant: "outlined",
                                                                              color: "primary",
                                                                              onClick: _withModifiers(($event: any) => (updateItemCantidad(item.ItemID, optionIndex, getItemCantidad(item.ItemID, optionIndex) + 1)), ["stop"])
                                                                            }, null, 8, ["onClick"]),
                                                                            _createElementVNode("span", _hoisted_9, " = " + _toDisplayString(formatCurrency(item.PrecioUnitario * getItemCantidad(item.ItemID, optionIndex))), 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["class", "onClick"])
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        }), 128))
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    (getItemsCountForSection(seccion.SeccionID, optionIndex) > 0)
                                                      ? (_openBlock(), _createBlock(_component_v_card, {
                                                          key: 0,
                                                          class: "mt-4",
                                                          variant: "outlined"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_card_title, { class: "text-subtitle-1 bg-blue-grey-lighten-5" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_icon, {
                                                                  start: "",
                                                                  color: "primary"
                                                                }, {
                                                                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                                    _createTextVNode("mdi-image-multiple")
                                                                  ])),
                                                                  _: 1,
                                                                  __: [28]
                                                                }),
                                                                _createTextVNode(" Referencia de Imágenes - " + _toDisplayString(seccion.NombreSeccion), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_card_text, { class: "pa-4" }, {
                                                              default: _withCtx(() => [
                                                                (getSectionImages(seccion.SeccionID, optionIndex).length > 0)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                                      _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-subtitle-2 font-weight-bold mb-3" }, "Imágenes seleccionadas:", -1)),
                                                                      _createVNode(_component_v_row, null, {
                                                                        default: _withCtx(() => [
                                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSectionImages(seccion.SeccionID, optionIndex), (imagen, index) => {
                                                                            return (_openBlock(), _createBlock(_component_v_col, {
                                                                              cols: "6",
                                                                              sm: "4",
                                                                              md: "4",
                                                                              lg: "4",
                                                                              key: `img-${seccion.SeccionID}-${index}`
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_card, {
                                                                                  class: "image-preview-card",
                                                                                  elevation: "2"
                                                                                }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_v_img, {
                                                                                      src: _unref(getImagePath)(imagen.image),
                                                                                      height: "120",
                                                                                      cover: "",
                                                                                      class: "rounded"
                                                                                    }, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_v_btn, {
                                                                                          size: "x-small",
                                                                                          icon: "mdi-close",
                                                                                          color: "error",
                                                                                          variant: "elevated",
                                                                                          density: "comfortable",
                                                                                          class: "remove-image-btn",
                                                                                          onClick: ($event: any) => (removeImageFromSection(seccion.SeccionID, index, optionIndex))
                                                                                        }, null, 8, ["onClick"])
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1032, ["src"]),
                                                                                    _createVNode(_component_v_card_subtitle, { class: "text-caption pa-2 text-center" }, {
                                                                                      default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(imagen.title), 1)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024))
                                                                          }), 128)),
                                                                          _createVNode(_component_v_col, {
                                                                            cols: "6",
                                                                            sm: "4",
                                                                            md: "4",
                                                                            lg: "4"
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              (loaderImagen.value)
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                                                    _createVNode(_component_v_skeleton_loader, {
                                                                                      type: "image@1",
                                                                                      loading: true,
                                                                                      class: "mb-4",
                                                                                      height: "75"
                                                                                    })
                                                                                  ]))
                                                                                : _createCommentVNode("", true)
                                                                            ]),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                _createElementVNode("div", _hoisted_12, [
                                                                  _createElementVNode("label", _hoisted_13, [
                                                                    _createVNode(_component_v_icon, {
                                                                      large: "",
                                                                      color: "#dbdbdb"
                                                                    }, {
                                                                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                                                                        _createTextVNode("mdi-plus-circle-outline")
                                                                      ])),
                                                                      _: 1,
                                                                      __: [30]
                                                                    }),
                                                                    _cache[31] || (_cache[31] = _createElementVNode("span", { class: "add-text" }, "agregar referencia", -1)),
                                                                    _createElementVNode("input", {
                                                                      type: "file",
                                                                      accept: "image/*",
                                                                      multiple: "",
                                                                      style: {"display":"none"},
                                                                      onChange: ($event: any) => (handleImageUpload($event, seccion.SeccionID, optionIndex))
                                                                    }, null, 40, _hoisted_14)
                                                                  ])
                                                                ])
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["disabled"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)), [
                                [_vShow, getLengthItemsForService(servicio.ServicioID, optionIndex) > 0]
                              ])
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_v_card, {
                          class: "mt-6",
                          elevation: "2",
                          color: "grey-lighten-5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "text-h6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  start: "",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                                    _createTextVNode("mdi-calculator")
                                  ])),
                                  _: 1,
                                  __: [32]
                                }),
                                _createTextVNode(" Resumen de " + _toDisplayString(option.nombre), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      md: "3"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[33] || (_cache[33] = _createElementVNode("div", { class: "text-caption text-grey-darken-1" }, "Items seleccionados", -1)),
                                        _createElementVNode("div", _hoisted_15, _toDisplayString(option.selectedItems.length), 1)
                                      ]),
                                      _: 2,
                                      __: [33]
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      md: "3"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "text-caption text-grey-darken-1" }, "Subtotal", -1)),
                                        _createElementVNode("div", _hoisted_16, _toDisplayString(formatCurrency(calculateSubtotalForOption(optionIndex))), 1)
                                      ]),
                                      _: 2,
                                      __: [34]
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      md: "3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_17, "Descuento (" + _toDisplayString(discountPercent.value) + "%)", 1),
                                        _createElementVNode("div", _hoisted_18, " -" + _toDisplayString(formatCurrency(calculateDiscountForOption(optionIndex))), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      md: "3"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "text-caption text-grey-darken-1" }, "Total", -1)),
                                        _createElementVNode("div", _hoisted_19, _toDisplayString(formatCurrency(calculateTotalForOption(optionIndex))), 1)
                                      ]),
                                      _: 2,
                                      __: [35]
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-6",
        elevation: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5 pa-6 bg-grey-lighten-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                start: "",
                color: "primary"
              }, {
                default: _withCtx(() => _cache[36] || (_cache[36] = [
                  _createTextVNode("mdi-cog")
                ])),
                _: 1,
                __: [36]
              }),
              _cache[37] || (_cache[37] = _createTextVNode(" Configuración General "))
            ]),
            _: 1,
            __: [37]
          }),
          _createVNode(_component_v_card_text, { class: "pa-6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: discountPercent.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((discountPercent).value = $event)),
                        modelModifiers: { number: true },
                        label: "Descuento General (%)",
                        type: "number",
                        variant: "outlined",
                        density: "comfortable",
                        "prepend-inner-icon": "mdi-percent",
                        min: 0,
                        max: 100
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_textarea, {
                        modelValue: observations.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((observations).value = $event)),
                        label: "Observaciones Generales",
                        variant: "outlined",
                        density: "comfortable",
                        rows: "3",
                        "prepend-inner-icon": "mdi-note-text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "summary-fixed-card",
        elevation: "12"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "pa-6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { align: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "8"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_v_icon, {
                          start: "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => _cache[38] || (_cache[38] = [
                            _createTextVNode("mdi-file-document-multiple")
                          ])),
                          _: 1,
                          __: [38]
                        }),
                        _createTextVNode(" " + _toDisplayString(options.value.length) + " Opción" + _toDisplayString(options.value.length > 1 ? 'es' : '') + " creada" + _toDisplayString(options.value.length > 1 ? 's' : ''), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, " Total de items: " + _toDisplayString(getTotalItemsCount()), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "12",
                    class: "text-right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_actions, { class: "pa-6 bg-grey-lighten-4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            size: "x-large",
                            "prepend-icon": "mdi-content-save",
                            disabled: !canSave.value || saving.value,
                            loading: saving.value,
                            onClick: saveQuotation,
                            "min-width": "300"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(saving.value ? 'Guardando...' : 'Guardar Opciones'), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "loading"]),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            size: "x-large",
                            "prepend-icon": "mdi-content-save",
                            disabled: !canSave.value || saving.value,
                            loading: saving.value,
                            onClick: generatePDF,
                            "min-width": "300"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(saving.value ? 'Imprimiendo...' : 'Imprimir Cotización'), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "loading"]),
                          _createVNode(_component_v_spacer)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_snackbar, {
        modelValue: toast.value.show,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((toast.value.show) = $event)),
        color: toast.value.type,
        timeout: "3000",
        location: "top"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(toast.value.message), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "color"])
    ]),
    _: 1
  }))
}
}

})